const DisputeCountBox: React.FC<{
  label?: string;
  count: number;
  color: string;
}> = ({label, count, color}) => {
  return (
    <div
      className={`flex flex-col p-2 w-[150px] md:w-50 h-auto gap-1 border border-gray-300 rounded-md ${color} shadow-sm hover:shadow-md transition-shadow duration-200`}
    >
      <h3 className="text-xs text-gray-500 font-medium truncate">{label}</h3>
      <p className="text-lg text-gray-900 font-bold">{count}</p>
    </div>
  );
};
export default DisputeCountBox;
